import { DateTime } from "luxon"
import From from "./From"
import To from "./To"

interface Props {
  companyName: string
  invoiceTimestamp: number
}

const Header = ({ companyName, invoiceTimestamp }: Props) => {
  const luxonTime = DateTime.fromSeconds(Number(invoiceTimestamp), {
    zone: "utc"
  })
  const currentMonth = luxonTime.toFormat("MMMM")
  const invoiceDate = luxonTime.toFormat("MMMM d yyyy")

  return (
    <>
      <h3 className="text-2xl font-bold">Invoice</h3>
      <div className="text-sm pt-2">
        {currentMonth} invoice:{" "}
        <time className="text-sm pt-2" dateTime={invoiceDate}>
          {invoiceDate}
        </time>
      </div>

      <div className="md:flex justify-between items-start pt-6">
        <From />
        <To name={companyName} />
      </div>
    </>
  )
}

export default Header
